import React, { useEffect, useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'moment/locale/hu'; // importálja a magyar locale-t a moment könyvtárból
import { VendegKezelo } from '../admin/vendegkezelo';
import { Berlesek_Table } from '../admin/table';
import { useNavigate } from 'react-router-dom';
import { id } from 'date-fns/locale';
import { BeatLoader } from 'react-spinners';

// Helyi idő beállítása a moment könyvtárral
const localizer = momentLocalizer(moment);


const messages = {
  allDay: 'Egész nap',
  previous: 'Előző',
  next: 'Következő',
  today: 'Ma',
  month: 'Hónap',
  week: 'Hét',
  day: 'Nap',
  agenda: 'Napirend',
  date: 'Dátum',
  time: 'Idő',
  event: 'Esemény',
  noEventsInRange: 'Nincs esemény ebben az időszakban.',
  showMore: total => `+ Még ${total}`
};

const exampleEvents = [
  {
    id: 1,
    title: 'Indonézia: Bali, Jáva, Karimun',
    start: new Date(2025, 5, 5),
    end: new Date(2025, 5, 22),
    color: '#4db6e1'  // világoskék
  },
  {
    id: 2,
    title: 'Bazardüzü – Trekking Azerbajdzsánban',
    start: new Date(2025, 6, 4),
    end: new Date(2025, 6, 12),
    color: '#ffb74d'  // narancsos
  },
  {
    id: 3,
    title: 'Izland: Vízesések és Lávamezők',
    start: new Date(2025, 7, 10),
    end: new Date(2025, 7, 20),
    color: '#81c784'  // zöldes
  },
  {
    id: 4,
    title: 'Nepál kalandtúra',
    start: new Date(2025, 9, 15),
    end: new Date(2025, 10, 2),
    color: '#9575cd'  // lila
  },
  {
    id: 5,
    title: 'Toubkal-expedíció',
    start: new Date(2025, 10, 28),
    end: new Date(2025, 11, 7),
    color: '#f06292'  // rózsaszín
  }
];


export function Gannt(){
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const url = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  
  const handleSelectEvent = (event) => {
    navigate(`/travel/${event.id}`);
  };

  

  useEffect(() => {
    async function fetchTravels() {
      try {
        const response = await fetch(url + "/api/naptar_adatok");
        if (!response.ok) {
          throw new Error("Nem sikerült lekérni az utazásokat.");
        }
        const data = await response.json();
        console.log("Backend adat:", data);
  
        // Itt alakítjuk át az eseményeket, például egész napossá tesszük őket
        const formattedEvents = data.map(event => ({
          ...event,
          start: new Date(event.start),
          // Ha például hozzáadsz egy napot az end értékhez:
          end: moment(event.end).add(1, 'day').toDate(),
          allDay: true
        }));
  
        setEvents(formattedEvents);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchTravels();
  }, []);
  

  if (loading) {
    return (
      <div className="loader-container">
        <BeatLoader color="#001662" size={30} loading={loading} aria-label="Loading Spinner" data-testid="loader" />
      </div>
    );
  }

  if (error) {
    return <div className="error">Hiba: {error}</div>;
  }
  return (
    <div>
    {
      <div>
     <Calendar
  localizer={localizer}
  events={events}
  startAccessor="start"
  endAccessor="end"
  style={{ height: 500 }}
  messages={messages}
  onSelectEvent={handleSelectEvent}
  eventPropGetter={() => ({
    style: {
      color: '#fff',              // Betűszín
      borderRadius: '4px',
      padding: '4px'
    }
  })}
/>


    </div>
    /*
      <VendegKezelo />
      <Berlesek_Table />
      */
    }
    </div>
  );
};